/**
 * How It Works — direct replica of brand-guide page 4 ("Brand Principles").
 *
 * Layout:
 *   - Cream page background.
 *   - Teal "HOW IT WORKS" eyebrow + big uppercase Night Ink headline.
 *   - 4 cards, each with a solid numbered circle (Purple → Teal → Orange → Purple)
 *     then title + body copy. No shadow halos, no gradient washes.
 */
const STEPS = [
  {
    n: 1,
    color: "#4E2C80", // Deep Purple — leads
    title: "Dream it up",
    body: "Your child describes their Buddy. Silly, spooky, sparkly — anything goes.",
  },
  {
    n: 2,
    color: "#06A5A1", // Buddy Teal — supports
    title: "Meet the Buddy",
    body: "We bring their character to life as a one-of-a-kind creation.",
  },
  {
    n: 3,
    color: "#F26A34", // Tongue Orange — small accent
    title: "Print and play",
    body: "Slide the Buddy under a clear plate and let the adventure begin.",
  },
  {
    n: 4,
    color: "#4E2C80", // Deep Purple returns to close the loop
    title: "Make it a ritual",
    body: "New Buddies, coloring sheets, and family cooking fun keep the world growing.",
  },
];

export default function HowItWorks() {
  return (
    <section data-testid="section-how" className="relative py-20 md:py-28 bg-gradient-to-br from-pb-brand-purple via-[#3A1F6B] to-pb-brand-ink overflow-hidden">
      {/* Subtle Buddy Teal glow top-right — same supporting-color move as the marquee. */}
      <div
        aria-hidden
        className="absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle, #06A5A1 0%, transparent 65%)", filter: "blur(40px)" }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="font-display font-black uppercase tracking-[0.2em] text-pb-brand-teal text-xs sm:text-sm">
            How it works
          </p>
          <h2 className="mt-3 font-display font-black uppercase text-white text-5xl md:text-6xl leading-[0.95] tracking-tight">
            Four playful<br />steps.
          </h2>
          <p className="mt-5 text-white/70 text-base sm:text-lg leading-relaxed">
            Designed to turn stressful meals into a repeatable family ritual &mdash; without screens, bribery, or short-order cooking.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`card-step-${i}`}
              className="relative bg-white rounded-[1.5rem] p-7 border-2 border-white/5 hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Numbered solid colored circle — brand-guide principles pattern. */}
              <div
                className="h-14 w-14 rounded-full flex items-center justify-center text-white font-display font-black text-xl"
                style={{ background: s.color }}
              >
                {String(s.n).padStart(2, "0")}
              </div>
              <h3 className="font-display font-black text-2xl mt-6 text-pb-brand-ink leading-tight">{s.title}</h3>
              <p className="text-pb-brand-ink/65 mt-2 leading-relaxed text-sm">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
